// @flow
import styled from "styled-components";

const List = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    padding: 10px 30px;
    border-bottom: 1px var(--border-color) solid;
  }
`;

export default List;
